module.exports = __webpack_public_path__ + "img/PL08448.1f2c82ac.png";